<template>
  <div
    class="container-wrapper"
    :class="{
      'background-registration': registrationShown,
      'background-approval': approvalShown,
      'background-profile': profileShown,
    }"
  >
    <registration-self-employed
      v-if="registrationShown"
    />
    <connecting-self-employed
      v-if="connectingShown"
    />
    <approval-self-employed
      v-if="approvalShown"
    />
    <auto-declaration
      v-if="profileShown"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import WS from '@/services/WebSocket';
import { SOCKET_INIT } from 'root/.env';

import RegistrationSelfEmployed from './components/RegistrationSelfEmployed';
import ConnectingSelfEmployed from './components/ConnectingSelfEmployed';
import ApprovalSelfEmployed from './components/ApprovalSelfEmployed';
import AutoDeclaration from './components/AutoDeclaration';

export default {
  name: 'SelfEmployed',
  components: {
    RegistrationSelfEmployed,
    ConnectingSelfEmployed,
    ApprovalSelfEmployed,
    AutoDeclaration,
  },
  created() {
    WS.open(SOCKET_INIT);

    this.GET_SELF_EMPLOYED_STATUS();
  },
  computed: {
    registrationShown() {
      return this.SELF_EMPLOYED.status === 'INACTIVE' || this.SELF_EMPLOYED.status === 'FAILED';
    },
    connectingShown() {
      return this.SELF_EMPLOYED.status === 'REQUEST_PENDING';
    },
    approvalShown() {
      return this.SELF_EMPLOYED.status === 'COMPLETED';
    },
    profileShown() {
      return this.SELF_EMPLOYED.status === 'ACTIVE';
    },
    ...mapState(['SELF_EMPLOYED']),
  },
  methods: {
    ...mapActions(['GET_SELF_EMPLOYED_STATUS']),
  },
};
</script>

<style lang="sass" scoped>
  .container-wrapper
    position: relative
    max-width: 68rem
    width: 100%
    margin-left: auto
    margin-right: auto

    &:after
      content: ''
      width: 100%
      height: 240px
      position: absolute
      top: 0
      right: 0
      background-repeat: no-repeat
      background-position: center center
      background-size: 60%

      +respond-to("small")
        width: 380px
        height: 410px
        background-position: 100% 40px
        background-size: auto

    &.background-registration
      &:after
        background-image: url("~@/assets/img/self-employed.svg")
        background-position: top -50% right -50%
        z-index: -1

        +respond-to("small")
          background-position: 100% 40px

    &.background-approval
      &:after
        background-image: url("~@/assets/img/self-employed-color.svg")

    &.background-profile
      &:after
        background-image: url("~@/assets/img/self-employed-color.svg")
        background-position: top -50% right -50%
        z-index: -1

        +respond-to("small")
          background-position: 100% 40px
</style>
